import {
  getCreatorList,
  getMySharingsMemberships,
} from "@api/Creators/Creators";
import { shareLink } from "@api/share";
import { Creator } from "@apiTypes";
import FButton from "@components/FButton";
import { FInput } from "@components/FInputs";
import Modal from "@components/Modals/Modal";
import { isEmpty } from "lodash";
import { useState } from "react";
import toast from "react-hot-toast";

const BUTTON_PROPS = {
  height: "40px",
  width: "140px",
};

interface ShareLinkModalProps {
  name: string;
  onClose: () => void;
}

const ShareLinkModal = ({ name, onClose }: ShareLinkModalProps) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [linkName, setLinkName] = useState(name);

  const [waiting, setWaiting] = useState(false);
  const [hasCheckedForCreator, setHasCheckedForCreator] = useState(false);

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const [creator, setCreator] = useState<Creator>(null);

  const handleSubmit = async () => {
    setWaiting(true);

    await getMySharingsMemberships();

    if (!email || !linkName) {
      setHasSubmitted(true);

      return;
    }

    setHasSubmitted(false);

    try {
      if (!creator && !hasCheckedForCreator) {
        const response = await getCreatorList(1, null, {
          email_eq: email,
        });

        const { creators } = response.data;

        if (!isEmpty(creators)) {
          setCreator(creators[0]);

          setWaiting(false);
        } else {
          setHasCheckedForCreator(true);
        }

        return;
      }

      if (!creator && (!firstName || !lastName)) {
        setHasSubmitted(true);

        return;
      }

      const baseParams = {
        email,
        url: window.location.href,
        shared_link_name: linkName,
      };

      const params = creator
        ? {
            ...baseParams,
            first_name: creator.firstName,
            last_name: creator.lastName,
          }
        : {
            ...baseParams,
            first_name: firstName,
            last_name: lastName,
          };

      await shareLink(params);

      toast.success("Page successfully shared");

      onClose();
    } catch (e) {
      toast.error("Error sharing link");
    } finally {
      setWaiting(false);
    }
  };

  return (
    <Modal title="Share link" onClose={onClose} isOpen hasForm>
      {hasCheckedForCreator ? (
        <>
          <FInput
            className="mb-2"
            value={firstName}
            onChange={setFirstName}
            required
            label="First name"
            validate={hasSubmitted}
            width="100%"
          />
          <FInput
            className="mb-2"
            value={lastName}
            onChange={setLastName}
            required
            label="Last name"
            validate={hasSubmitted}
            width="100%"
          />
        </>
      ) : null}
      <div className="flex flex-col gap-4">
        <FInput
          value={email}
          onChange={setEmail}
          required
          label="Email"
          width="100%"
        />
        <FInput
          className="mb-4"
          value={linkName}
          onChange={setLinkName}
          required
          label="Link name"
          validate={hasSubmitted}
          width="100%"
        />
      </div>
      {creator ? (
        <p className="mb-4 text-green text-sm">
          This email belongs to a creator. Do you really want to share the page?
        </p>
      ) : null}
      <div className="flex items-center justify-end gap-4">
        <FButton onClick={onClose} label="Cancel" {...BUTTON_PROPS} />
        <FButton
          onClick={handleSubmit}
          loading={waiting}
          label={creator ? "Confirm" : "Send"}
          {...BUTTON_PROPS}
          primary
        />
      </div>
    </Modal>
  );
};

export default ShareLinkModal;
